"use strict";

exports.__esModule = true;
exports.default = void 0;

var _default = function _default(value) {
  return value === null;
};

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/redux-actions/lib/utils/isNull.js
// module id = 1744
// module chunks = 0